import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import TVItem from './ProductsAndServicesItems/TVItem';
import InternetItem from './ProductsAndServicesItems/InternetItem';
import CellularItem from './ProductsAndServicesItems/CellularItem';
import BundleItem from './ProductsAndServicesItems/BundleItem';
import MabalItem from './ProductsAndServicesItems/MabalItem';
import MapaItem from './ProductsAndServicesItems/MapaItem';
import PopUp from '../../Shared/Popup/PopUp';
import CellularPackageData from './Popups/CellularPackageData';
import MabalSubscriberList from './Popups/MabalSubscriberList';
import DataUsageAlertPopup from './Popups/DataUsageAlertPopup';
import AllActionsPopup from './Popups/AllActionsPopup';
import {objectIsEmpty} from '../../../utilities/StringHelpers/StringHelpers';
import {ActionGroupType} from '../CoreProductActionsBlock/CoreProductEnum';
import {prepareUrl} from '../../../utilities/StringHelpers/StringHelpers';
import {getActionsByTypes} from '../CoreProductActionsBlock/CoreProductActionsSlice';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import lodash from 'lodash';

import {
  productsTypes,
  popupTypes,
  getCurrentPricePlan,
  closePopup,
  toAllActionButtonText,
  getAllActionsPopup,
  openDataUsageAlertPopup,
} from './productsAndServicesBlockSlice';
const ProductsAndServicesMain = (props) => {
  const epiCellularActions = props.iContent?.cellularOptionsList?.expandedValue;
  const epiTvActions = props.iContent?.tvOptionsList?.expandedValue;
  const epiInternetActions = props.iContent?.internetOptionsList?.expandedValue;
  const epiMapaActions = props.iContent?.mapaOptionsList?.expandedValue;
  const epiMabalActions = props.iContent?.mabalOptionsList?.expandedValue;
  const customerCoreProducts = props.coreProducts.coreProductsTypes;

  const [cellularActions, setCellularActions] = useState([]);
  const [tvActions, setTvActions] = useState([]);
  const [internetActions, setInternetActions] = useState([]);
  const [mapaActions, setMapaActions] = useState([]);
  const [mabalActions, setMabalActions] = useState([]);
  const isReady = props.productsAndServices.customerProducts && objectIsEmpty(props.productsAndServices.customerProducts) === false;

  useEffect(() => {
    const getActionsAsync = async () => {
      let orgActions = await getActionsByTypes(customerCoreProducts, ActionGroupType.ACTIONS);
      getActionsForBusiness(orgActions);
    };

    if (props.coreProducts.isActionsReady && customerCoreProducts?.length > 0) {
      if (props.organizationData?.organizationCodeList?.length > 0) {
        getActionsAsync();
      } else {
        setCellularActions(epiCellularActions);
        setTvActions(epiTvActions);
        setInternetActions(epiInternetActions);
        setMapaActions(epiMapaActions);
        setMabalActions(epiMabalActions);
      }
    }
  }, [props.coreProducts.isActionsReady]);

  useEffect(() => {
    if (props.productsAndServices.isLoading) {
      props.showAppLoader();
    } else {
      props.hideAppLoader();
    }
  }, [props.productsAndServices.isLoading]);

  function getActionsForBusiness(orgActions) {
    customerCoreProducts.map((pr) => {
      switch (pr) {
        case productsTypes.CELLULAR:
          if (epiCellularActions) {
            let cellActions = filterActionsForBusiness(orgActions, epiCellularActions);
            if (cellActions) {
              setCellularActions(cellActions);
            }
          }
          break;
        case productsTypes.TV:
          if (epiTvActions) {
            let tvActions = filterActionsForBusiness(orgActions, epiTvActions);
            if (tvActions) {
              setTvActions(tvActions);
            }
          }
          break;
        case productsTypes.INTERNET:
          if (epiInternetActions) {
            let internetActions = filterActionsForBusiness(orgActions, epiInternetActions);
            if (internetActions) {
              setInternetActions(internetActions);
            }
          }
          break;
        case productsTypes.MAPA:
          if (epiMapaActions) {
            let mapaActions = filterActionsForBusiness(orgActions, epiMapaActions);
            if (mapaActions) {
              setMapaActions(mapaActions);
            }
          }
          break;
        case productsTypes.MABAL:
          if (epiMabalActions) {
            let mabalActions = filterActionsForBusiness(orgActions, epiMabalActions);
            if (mabalActions) {
              setMabalActions(mabalActions);
            }
          }
          break;
        default:
          break;
      }
    });
  }

  function filterActionsForBusiness(orgActions, epiActions) {
    const commonActions = lodash.filter(orgActions, function (org) {
      return epiActions.some((epiAction) => epiAction.contentLink.id == org.actionId);
    });
    if (commonActions?.length > 0) return commonActions.slice(0, 3);
    else return [];
  }

  function goToAction(actionUrl) {
    prepareUrl(actionUrl, props.context);
  }

  async function goToAllAction(type) {
    let result = await getActionsByTypes([type], ActionGroupType.ACTIONS);
    props.getAllActionsPopup({actions: result, title: type});
  }

  const renderBundleItems = () => {
    if (props.productsAndServices.customerProducts?.Bundle?.length > 0) {
      return (
        <BundleItem
          bundleItems={props.productsAndServices.customerProducts?.Bundle}
          type={productsTypes.BUNDLE}
          toAllActionButtonText={toAllActionButtonText}
          goToAllAction={goToAllAction}
        />
      );
    } else return null;
  };
  const renderCellularItems = () => {
    if (props.productsAndServices.customerProducts?.Cellular) {
      return (
        <CellularItem
          cellularItems={props.productsAndServices.customerProducts?.Cellular}
          dataUsageUrl={props.iContent.cellularDataUsageUrl?.value}
          context={props.context}
          type={productsTypes.CELLULAR}
          getCurrentPricePlan={props.getCurrentPricePlan}
          cellularActions={cellularActions}
          goToAction={goToAction}
          goToAllAction={goToAllAction}
          allActionButtonText={toAllActionButtonText.cellular}
          toAllActionsMobile={toAllActionButtonText.mobileText}
          openDataUsageAlertPopup={props.openDataUsageAlertPopup}
        />
      );
    } else return null;
  };
  const renderTvItems = () => {
    if (props.productsAndServices.customerProducts?.TV) {
      return (
        <TVItem
          tvItems={props.productsAndServices.customerProducts?.TV}
          type={productsTypes.TV}
          context={props.context}
          getCurrentPricePlan={props.getCurrentPricePlan}
          tvActions={tvActions}
          goToAction={goToAction}
          goToAllAction={goToAllAction}
          allActionButtonText={toAllActionButtonText.tv}
          toAllActionsMobile={toAllActionButtonText.mobileText}
        />
      );
    } else return null;
  };

  const renderInternetItems = () => {
    if (props.productsAndServices.customerProducts?.InternetInfra || props.productsAndServices.customerProducts?.InternetIsp)
      return (
        <InternetItem
          infra={props.productsAndServices.customerProducts?.InternetInfra}
          isp={props.productsAndServices.customerProducts?.InternetIsp}
          type={productsTypes.INTERNET}
          context={props.context}
          getCurrentPricePlan={props.getCurrentPricePlan}
          internetActions={internetActions}
          goToAction={goToAction}
          goToAllAction={goToAllAction}
          allActionButtonText={toAllActionButtonText.internet}
          toAllActionsMobile={toAllActionButtonText.mobileText}
        />
      );
  };

  const renderMabalItems = () => {
    if (props.productsAndServices.customerProducts?.Mabal)
      return (
        <MabalItem
          mabalItems={props.productsAndServices.customerProducts?.Mabal}
          type={productsTypes.MABAL}
          context={props.context}
          getCurrentPricePlan={props.getCurrentPricePlan}
          mabalActions={mabalActions}
          goToAction={goToAction}
          goToAllAction={goToAllAction}
          toAllActionsMobile={toAllActionButtonText.mobileText}
        />
      );
  };
  const renderMapaItems = () => {
    if (props.productsAndServices.customerProducts?.Mapa || props.productsAndServices.customerProducts?.MapaKosher)
      return (
        <MapaItem
          mapaItems={props.productsAndServices.customerProducts?.Mapa}
          mapaKosherItems={props.productsAndServices.customerProducts?.Kosher}
          type={productsTypes.MAPA}
          context={props.context}
          getCurrentPricePlan={props.getCurrentPricePlan}
          mapaActions={mapaActions}
          goToAction={goToAction}
          goToAllAction={goToAllAction}
          toAllActionsMobile={toAllActionButtonText.mobileText}
        />
      );
  };

  const getPopupContent = () => {
    if (props.productsAndServices.popup.popupOpen) {
      switch (props.productsAndServices.popup.popupType) {
        case popupTypes.CELL_PACK_DATA:
          return <CellularPackageData package={props.productsAndServices.popup.popupData} />;
        case popupTypes.MABAL_SUBSCRIBERS:
          return <MabalSubscriberList subscribers={props.productsAndServices.popup.popupData} />;
        case popupTypes.DATA_USAGE_ALERT:
          return <DataUsageAlertPopup />;
        case popupTypes.ALL_ACTIONS:
          return (
            <AllActionsPopup
              actions={props.productsAndServices.popup.popupData}
              title={props.productsAndServices.popup.popupTitle}
              goToAction={goToAction}
            />
          );
        default:
          return null;
      }
    }
  };
  return (
    <div className='my-products-main-container'>
      <div className={`productsAndServicesSelfcare_wrapper ${isReady ? 'pb-15 pt-15' : ''}`}>
        {isReady && <div className='productsAndServicesSelfcare_wrapper_title'>המוצרים שלך</div>}
        {renderBundleItems()}
        {renderCellularItems()}
        {renderTvItems()}
        {renderInternetItems()}
        {renderMapaItems()}
        {renderMabalItems()}
        <PopUp
          className={`productsAndServices_popup_${props.productsAndServices.popup.popupType}`}
          showPopUp={props.productsAndServices.popup.popupOpen}
          onClose={() => props.closePopup()}>
          {getPopupContent()}
        </PopUp>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  productsAndServices: state.productsAndServices,
  coreProducts: state.coreProductActions,
  organizationData: state.welcomeBlock?.organizationState,
});

const mapDispatchToProps = {
  getCurrentPricePlan,
  closePopup,
  getAllActionsPopup,
  openDataUsageAlertPopup,
  showAppLoader,
  hideAppLoader,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductsAndServicesMain);
